import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { getUserData } from '../../util/manageUserData';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private httpClient: HttpClient) {}

  private readonly HOST_URL = environment.url_host;

  loginUser(userName: string, password: string): Promise<any> {
    const LOGIN_URL = `${this.HOST_URL}/login`;
    // const LOGIN_URL = 'https://glimpseanalytics.free.beeceptor.com/login'
    const body = new HttpParams()
      .set('username', userName.trim())
      .set('password', password.trim());

    // headers: {
    //   "Authorization": "Basic " + btoa('glimpse_user_name' + ":" + 'glimpse_main_password_123')
    // },
    let bearerToken = btoa(
      'glimpse_user_name' + ':' + 'glimpse_main_password_123',
    );
    const header = new HttpHeaders().set(
      'Authorization',
      `Basic ${bearerToken}`,
    );
    // .set('Access-Control-Allow-Origin','*')
    // .set('Access-Control-Allow-Methods','POST')

    // header.set('Authorization',`Basic ${bearerToken}`);
    header.set('Content-Type', 'application/x-www-form-urlencoded');

    return this.httpClient
      .post(LOGIN_URL, body, { headers: header })
      .toPromise();
  }

  loginForPandG(code: string): Promise<any> {
    const LOGIN_URL = `${this.HOST_URL}/login_oauth_png`;
    const body = new HttpParams().set('token', code.trim());

    let bearerToken = btoa(
      'glimpse_user_name' + ':' + 'glimpse_main_password_123',
    );
    const header = new HttpHeaders().set(
      'Authorization',
      `Basic ${bearerToken}`,
    );

    // header.set('Authorization',`Basic ${bearerToken}`);
    header.set('Content-Type', 'application/x-www-form-urlencoded');

    return this.httpClient
      .post(LOGIN_URL, body, { headers: header })
      .toPromise();
  }

  logOutUser() {
    localStorage.clear();
    const userDataStorage = getUserData();
    if (userDataStorage == undefined || userDataStorage == null) {
      return true;
    }
    return false;
  }

  isUserLogedIn() {
    const userDataStorage = getUserData();
    if (userDataStorage) {
      if (userDataStorage['token']) {
        return true;
      }
    } else {
      return false;
    }
  }

  getPINGBeareToken(code: string) {
    const URL = 'https://fedauth.pg.com/as/token.oauth2';
    const client_secret =
      '1lrj80ffbhzdcqPWcvCQEz9cqne8yDtpNdK9xj8lHdipT4NdU9ilpc0yAU6nQj2n';
    const client_id = 'GlimpseSurakshaClientID';
    const grant_type = 'authorization_code';
    const httpParams = new HttpParams()
      .set('client_secret', client_secret)
      .set('client_id', client_id)
      .set('grant_type', grant_type)
      .set('code', code);

    return this.httpClient.post(URL, httpParams, {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded',
      ),
    });
  }
}
